export default __webpack_public_path__ + "static/media/multi_acc1.ae89e076.png";